import { createFileRoute } from "@tanstack/react-router";
import { Webhooks } from "../../../features/settings/webhooks";

export const Route = createFileRoute("/_authed/$org/settings/webhooks/")({ component: WebhooksPage });

function WebhooksPage() {
  return <Webhooks org={Route.useParams().org} />;
}
